module.exports = __webpack_public_path__ + "static/media/banner-1000x370.93ed5353.jpg";